import Account from '__core/shared/model/account/Account';
import AccountUser from '__core/shared/model/account/AccountUser';
import AccountExchange from '__core/shared/model/account/AccountExchange';
import AccountAccreditation from '__core/shared/model/account/AccountAccreditation';
import AccountLenderAccreditation from '__core/shared/model/account/AccountLenderAccreditation';
import AccountGatewayAccreditation from '__core/shared/model/account/AccountGatewayAccreditation';
import AccountPartnerAttributes from '__core/shared/model/account/AccountPartnerAttributes';
import accountController from './account.controller';
import stAccountAdd from './accountAdd.component';
import stAccountDelete from './accountDelete.component';
import accountsController from './accounts.controller';
import stAccountDetails from './accountDetails.component';
import stAccountsList from './accountsList.component';
import accreditationsController from './accreditations.controller';
import stAccountAccreditations from './accountAccreditations.component';
import stMentorAssign from './mentorAssign.component';
import stPartnerAssign from './partnerAssign.component';
import stPartnerDelete from './partnerDelete.component';
import stPartnersList from './partnersList.component';
import passwordAndSecurityController from './passwordAndSecurity.controller';
import personalizationController from './personalization.controller';
import stAccountPersonalization from './accountPersonalization.component';
import updatesAndRemindersController from './updatesAndReminders.controller';
import stAccountUpdatesAndReminders from './accountUpdatesAndReminders.component';

export default angular
  .module('st.Account', ['st.Core', 'angular-cache'])
  .factory('Account', () => Account)
  .factory('AccountUser', () => AccountUser)
  .factory('AccountExchange', () => AccountExchange)
  .factory('Accreditation', () => AccountAccreditation)
  .factory('LenderAccreditation', () => AccountLenderAccreditation)
  .factory('GatewayAccreditation', () => AccountGatewayAccreditation)
  .factory('PartnerAttributes', () => AccountPartnerAttributes)
  .service('accountService', ($http, dataService, Account) => ({
    createAccount: (doc, params) => dataService.createDocument(Account, doc, params),
    deleteAccount: (doc) => dataService.deleteDocument(Account, doc),
    readAccount: (doc) => dataService.readDocument(Account, doc),
    updateAccount: (doc) => dataService.updateDocument(Account, doc)
  }))
  .service(
    'accountsService',
    ($http, $rootScope, CacheFactory, dataService, Account, ACCOUNT) => {
      let cache;
      if (!CacheFactory.get(ACCOUNT.CACHE.NAME)) {
        cache = CacheFactory(ACCOUNT.CACHE.NAME, ACCOUNT.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || ACCOUNT.CACHE.NAME,
          params
        });
      return {
        clearCache: () => cache.removeAll(),
        getAvailable: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params),
            params?.ignoreCache === true,
            Account.build,
            $http.get,
            ACCOUNT.API.AVAILABLE,
            { params }
          ),
        getSpecific: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getSpecific'),
            params?.ignoreCache === true,
            Account.build,
            $http.post,
            ACCOUNT.API.SPECIFIC,
            { params }
          ),
        getInEnterprise: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getInEnterprise'),
            params?.ignoreCache === true,
            Account.build,
            $http.get,
            ACCOUNT.API.IN_ENTERPRISE,
            { params: params }
          ),
        getInOrganization: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getInOrganization'),
            params?.ignoreCache === true,
            Account.build,
            $http.get,
            ACCOUNT.API.IN_ORGANIZATION,
            { params: params }
          ),
        getInInstance: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getInInstance'),
            params?.ignoreCache === true,
            null,
            $http.get,
            ACCOUNT.API.IN_INSTANCE,
            { params: {} }
          ),
        deleteAccounts: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'deleteAccounts'),
            params?.ignoreCache === true,
            Account.build,
            $http.post,
            ACCOUNT.API.DELETE,
            { params }
          )
      };
    }
  )
  .service(
    'partnersService',
    ($http, $rootScope, CacheFactory, dataService, Account, PARTNER) => {
      let cache;
      if (!CacheFactory.get(PARTNER.CACHE.NAME)) {
        cache = CacheFactory(PARTNER.CACHE.NAME, PARTNER.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || PARTNER.CACHE.NAME,
          params
        });
      return {
        clearCache: () => cache.removeAll(),
        getAvailable: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params),
            params?.ignoreCache === true,
            Account.build,
            $http.get,
            PARTNER.API.AVAILABLE,
            { params }
          ),
        getSpecific: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getSpecific'),
            params?.ignoreCache === true,
            Account.build,
            $http.post,
            PARTNER.API.SPECIFIC,
            { params }
          ),
        deletePartners: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params),
            true,
            null,
            $http.post,
            PARTNER.API.DELETE,
            { params }
          )
      };
    }
  )
  .controller('accountController', accountController)
  .component('stAccountAdd', stAccountAdd)
  .component('stAccountDelete', stAccountDelete)
  .controller('accountsController', accountsController)
  .component('stAccountsList', stAccountsList)
  .component('stAccountDetails', stAccountDetails)
  .controller('accreditationsController', accreditationsController)
  .component('stAccountAccreditations', stAccountAccreditations)
  .component('stMentorAssign', stMentorAssign)
  .component('stPartnerAssign', stPartnerAssign)
  .component('stPartnerDelete', stPartnerDelete)
  .component('stPartnersList', stPartnersList)
  .controller('passwordAndSecurityController', passwordAndSecurityController)
  .controller('personalizationController', personalizationController)
  .component('stAccountPersonalization', stAccountPersonalization)
  .controller('updatesAndRemindersController', updatesAndRemindersController)
  .component('stAccountUpdatesAndReminders', stAccountUpdatesAndReminders)
  .constant('ACCOUNT', {
    API: {
      AVAILABLE: '/api/v1/accounts/available/',
      SPECIFIC: '/api/v1/accounts/specific/',
      DELETE: '/api/v1/accounts/delete/',
      IN_ENTERPRISE: '/api/v1/accounts/enterprise/',
      IN_ORGANIZATION: '/api/v1/accounts/organization/',
      IN_INSTANCE: '/api/v1/accounts/instance/',
      UPLOAD: '/api/v1/account/avatar-upload/'
    },
    GATEWAYS: [
      { id: 1, value: 'Apply Online' },
      { id: 2, value: 'Simpology' },
      { id: 3, value: 'E-Lodge' },
      { id: 4, value: 'Drive Online' }
    ],
    LIMITS: {
      MULTIPLE: false,
      ALLOWED_MIME: 'image/*',
      ALLOWED_EXTENSIONS: '.jpeg,.jpg,.png',
      MIN_WIDTH: '256',
      MIN_HEIGHT: '256'
    },
    FIELDS: {
      LIST: {
        list: [
          'id',
          'accreditations',
          'lenderAccreditations',
          'externalReferenceId',
          'integrations',
          { user: ['avatar', 'firstName', 'lastName', 'eMail', 'prefix', 'phone', 'location'] },
          'isBroker',
          'isMentor',
          'isBillable',
          'isDisabled',
          'isActive'
        ]
      },
      LIST_COMPACT: {
        list: [
          'id',
          'externalReferenceId',
          { user: ['avatar', 'firstName', 'lastName', 'eMail', 'licenses'] },
          'isBroker',
          'isMentor',
          'isBillable',
          'isDisabled',
          'isActive'
        ]
      },
      CHIPS: {
        list: ['id', { user: ['avatar', 'firstName', 'lastName', 'eMail'] }]
      }
    },
    CACHE: {
      NAME: 'accountsCache',
      STORE: {
        TTL: 60 * 1000,
        DELETION: 'aggressive',
        RECYCLE: 30 * 1000,
        STORAGE: 'sessionStorage'
      }
    }
  })
  .constant('PARTNER', {
    API: {
      AVAILABLE: '/api/v1/partners/available/',
      SPECIFIC: '/api/v1/partners/specific/',
      DELETE: '/api/v1/partners/delete/'
    },
    TYPES: [
      { id: 1, name: 'Real Estate Sales Agent' },
      { id: 2, name: 'Real Estate Principal' },
      { id: 3, name: 'Property Manager' },
      { id: 4, name: 'Accountant' },
      { id: 5, name: 'Financial Adviser' },
      { id: 6, name: 'Buyers Agent' },
      { id: 7, name: 'Lead Generator' },
      { id: 8, name: 'Broker' },
      { id: 10, name: 'Franchised Dealer' },
      { id: 11, name: 'Dealership' },
      { id: 12, name: 'Car Buying Advocate' },
      { id: 13, name: 'Fleet Buyer' },
      { id: 14, name: 'Wholesaler/Manufacturer' },
      { id: 9, name: 'Other' }
    ],
    FIELDS: {
      LIST: {
        list: [
          'id',
          'externalReferenceId',
          { user: ['avatar', 'firstName', 'lastName', 'eMail', 'prefix', 'phone', 'location'] },
          'isBillable',
          'isDisabled',
          'isActive'
        ]
      },
      CHIPS: {
        list: ['id', { user: ['avatar', 'firstName', 'lastName', 'eMail'] }]
      }
    },
    CACHE: {
      NAME: 'partnersCache',
      STORE: {
        TTL: 60 * 1000,
        DELETION: 'aggressive',
        RECYCLE: 30 * 1000,
        STORAGE: 'sessionStorage'
      }
    }
  });
